import { MarketType } from "../custom-types/market-type";
import { generateQueryString } from "../methods/generateQueryString";
export const ROUTES = {
    transporterProfile: {
        withParam: "/transporters/:src/:transporterName/:transporterId",
        getUrl: (src: string, transporterName: string, transporterId: string) =>
            `/transporters/profile/${src?.replace?.(/ /g, "-")?.toLowerCase?.()}/${transporterName
                ?.replace?.(/ /g, "-")
                ?.replace?.(/,/g, "-")
                ?.replace?.(/--/g, "-")
                ?.replace?.(/\s|\.|\//g, "-")
                ?.toLowerCase?.()}/${transporterId}`,
        getUrlWithId: (transporterId: number) => `/transporters/profile/${transporterId}`
    },
    transporterProfileDetail: {
        getUrl: (transporterId: number) => `/transporters/profile/detail/${transporterId}`
    },
    transporterReviews: {
        withParam: "/transporters/:src/:transporterName/:transporterId/reviews",
        getUrl: (src: string, transporterName: string, transporterId: string) =>
            `/transporters/profile/${src?.replace?.(/ /g, "-")?.toLowerCase?.()}/${transporterName
                ?.replace?.(/ /g, "-")
                ?.replace?.(/,/g, "-")
                ?.replace?.(/--/g, "-")
                ?.replace?.(/\./g, "")
                ?.toLowerCase?.()}/${transporterId}/reviews`
    },
    marketplace: {
        withParam: [
            "/marketplace-ae/:mktType/to-:dest",
            "/marketplace-ae/:mktType/:src-to-:dest",
            "/marketplace-ae/:mktType/:src",
            "/marketplace-ae/:mktType",
            "/marketplace/:mktType/to-:dest",
            "/marketplace/:mktType/:src-to-:dest",
            "/marketplace/:mktType/:src",
            "/marketplace/:mktType"
        ],
        getUrl: (mktType: MarketType, src?: string, dest?: string, isABtestingRoute?: boolean) => {
            let url = "";
            if (src && dest) {
                url = `/marketplace/${mktType}/${src}-to-${dest}`;
            } else if (src) {
                url = `/marketplace/${mktType}/${src}`;
            } else if (dest) {
                url = `/marketplace/${mktType}/to-${dest}`;
            } else {
                url = `/marketplace/${mktType}`;
            }
            url = url?.replace?.(/ /g, "-")?.replace?.(/,/g, "-")?.replace?.(/--/g, "-")?.toLowerCase?.();
            if (isABtestingRoute) url = url.replace("marketplace", "marketplace-ae");
            return url;
        }
    },
    loadBid: {
        withParam: ["/marketplace/load/:src-to-:dest#id"],
        getUrl: (src?: string, dest?: string, loadId?: number | string, companyId?: number | string) => {
            return `/marketplace/load/${src}-to-${dest}?oppCmpId=${companyId}&loadbid=${loadId}`
                ?.replace?.(/ /g, "-")
                .toLowerCase?.();
        }
    },
    lorryBid: {
        withParam: ["/marketplace/lorry/:src#id"],
        getUrl: (src?: string, lorryId?: number | string, companyId?: number | string) => {
            return `/marketplace/lorry/${src}?oppCmpId=${companyId}&lorrybid=${lorryId}`
                ?.replace?.(/ /g, "-")
                ?.toLowerCase?.();
        }
    },

    bidHistory: {
        withParam: ["/:mktType-marketplace/bid-history"],
        getUrl: (mktType: MarketType) => `/${mktType}-marketplace/bid-history`
    },

    transporters: {
        withParam: ["/transporters"],
        getUrl: (src?: string, dest?: string) => {
            const baseUrl = "/transporters";
            src = src?.replace?.(/ /g, "-")?.replace?.(/,/g, "-")?.replace?.(/--/g, "-")?.toLowerCase?.();
            dest = dest?.replace?.(/ /g, "-")?.replace?.(/,/g, "-")?.replace?.(/--/g, "-")?.toLowerCase?.();
            if (src && dest) {
                return `${baseUrl}/${src}-to-${dest}`;
            }
            if (src) {
                return `${baseUrl}/${src}`;
            }
            if (dest) {
                return `${baseUrl}/for-${dest}`;
            }
            return baseUrl;
        }
    },

    pageNotFound: {
        withParam: "/page-not-found",
        getUrl: () => "/page-not-found"
    },
    dashboard: {
        withParam: "/dashboard",
        getUrl: () => "/dashboard"
    },
    userProfile: {
        withParam: "/my-profile",
        getUrl: () => "/my-profile"
    },
    userProfileEdit: {
        withParam: "/my-profile/edit",
        getUrl: () => "/my-profile/edit"
    },
    adminConsole: {
        withParam: "/",
        getUrl: () => "/"
    },
    adminConsoleLogin: {
        withParam: "/login",
        getUrl: () => "/login"
    },
    adminConsoleExecutives: {
        withParam: "/executives",
        getUrl: () => "/executives"
    },
    adminConsoleRecords: {
        withParam: "/records",
        getUrl: () => "/records"
    },
    adminConsoleCustomer: {
        withParam: "/customer-login",
        getUrl: () => "/customer-login"
    },
    adminConsoleCustomerProfile: {
        withParam: "/customer-profile",
        getUrl: () => "/customer-profile"
    },
    adminConsoleCustomerProfileEdit: {
        withParam: "/customer-profile/edit",
        getUrl: () => "/customer-profile/edit"
    },
    adminConsoleCustomerMarketplace: {
        withParam: [
            "/customer-marketplace/:mktType/to-:dest",
            "/customer-marketplace/:mktType/:src-to-:dest",
            "/customer-marketplace/:mktType/:src",
            "/customer-marketplace/:mktType"
        ],
        getUrl: (mktType: MarketType, src?: string, dest?: string) => {
            let url = "";
            if (src && dest) {
                url = `/customer-marketplace/${mktType}/${src}-to-${dest}`?.replace?.(/ /g, "-")?.toLowerCase?.();
            } else if (src) {
                url = `/customer-marketplace/${mktType}/${src}`?.replace?.(/ /g, "-")?.toLowerCase?.();
            } else if (dest) {
                url = `/customer-marketplace/${mktType}/to-${dest}`?.toLowerCase?.();
            } else {
                url = `/customer-marketplace/${mktType}`;
            }
            return url;
        }
    },
    adminConsoleEditProfile: {
        withParam: "/edit-profile",
        getUrl: () => "/edit-profile"
    },
    adminConsoleEditPassword: {
        withParam: "/edit-password",
        getUrl: () => "/edit-password"
    },
    adminConsoleCreateId: {
        withParam: "/executives/createid",
        getUrl: () => "/executives/createid"
    },
    adminConsoleBlockUsers: {
        withParam: "/block-users",
        getUrl: () => "/block-users"
    },
    adminConsoleSendWhatsAppMessage: {
        withParam: "/send-whatsapp-message",
        getUrl: () => "/send-whatsapp-message"
    },
    adminConsoleGlobalSearchResult: {
        withParam: "/search",
        getUrl: () => "/search"
    },

    listing: {
        withParam: "/ac/my-loads/listing/:id",
        getUrl: (id: number | string) => `/ac/my-loads/listing/${id}`
    },

    myLoadsMyLorries: {
        withParam: [
            "/ac/my-:mktType/:activeTab/to-:dest",
            "/ac/my-:mktType/:activeTab/:src-to-:dest",
            "/ac/my-:mktType/:activeTab/:src",
            "/ac/my-:mktType/:activeTab"
        ],
        getUrl: (mktType: MarketType, activeTab: string, src?: string, dest?: string) => {
            let url = "";
            if (src && dest) {
                url = `/ac/my-${mktType}/${activeTab}/${src}-to-${dest}`.replace(/ /g, "-")?.toLowerCase();
            } else if (src) {
                url = `/ac/my-${mktType}/${activeTab}/${src}`.replace(/ /g, "-").toLowerCase();
            } else if (dest) {
                url = `/ac/my-${mktType}/${activeTab}/to-${dest}`.replace(/ /g, "-").toLowerCase();
            } else {
                url = `/ac/my-${mktType}/${activeTab}`;
            }
            return url;
        }
    },
    adminConsoleMyLoadsMyLorries: {
        withParam: [
            "/customer-:mktType/:activeTab/to-:dest",
            "/customer-:mktType/:activeTab/:src-to-:dest",
            "/customer-:mktType/:activeTab/:src",
            "/customer-:mktType/:activeTab"
        ],
        getUrl: (mktType: string, activeTab: string, src?: string, dest?: string) => {
            let url = "";
            if (src && dest) {
                url = `/customer-${mktType}/${activeTab}/${src}-to-${dest}`?.replace?.(/ /g, "-")?.toLowerCase?.();
            } else if (src) {
                url = `/customer-${mktType}/${activeTab}/${src}`.replace?.(/ /g, "-")?.toLowerCase?.();
            } else if (dest) {
                url = `/customer-${mktType}/${activeTab}/to-${dest}`?.toLowerCase?.();
            } else {
                url = `/customer-${mktType}/${activeTab}`;
            }
            return url;
        }
    },
    help: {
        withParam: "/help",
        getUrl: () => "/help"
    },
    adminConsoleTrackScreen: {
        withParam: `/track-vehicle`,
        getUrl: () => `/track-vehicle`
    },
    adminConsoleMobileViewHome: {
        withParam: `/mw`,
        getUrl: () => `/mw`
    },
    adminConsoleMobileViewTrackScreen: {
        withParam: `/mw/track-vehicle`,
        getUrl: () => `/mw/track-vehicle`
    },
    adminConsoleMobileViewPhysicalVerifyDoc: {
        withParam: `/mw/physical-verify-doc`,
        getUrl: (ticketId?: string) => {
            let url = `/mw/physical-verify-doc`;
            if (ticketId) {
                url = `${url}/${ticketId}`;
            }
            return url;
        }
    },
    adminConsoleMobileViewMyReferral: {
        withParam: `/mw/my-referral`,
        getUrl: (isNew: boolean = false, cid: string = "") => {
            let url = `/mw/my-referral`;
            if (isNew && !cid) {
                url += "/new";
            }
            if (cid && !isNew) {
                url += `/my-user/${cid}`;
            }
            return url;
        }
    },
    adminConsoleMobileViewAssuredLoadPosted: {
        withParam: `/mw/tso/load/assured-spot`,
        getUrl: () => `/mw/tso/load/assured-spot`
    },
    adminConsoleMobileViewLoadPosted: {
        withParam: `/mw/tso/load/active`,
        getUrl: () => `/mw/tso/load/active`
    },
    adminConsoleMobileViewInTransitLoads: {
        withParam: `/mw/tso/load/in-transit`,
        getUrl: () => `/mw/tso/load/in-transit`
    },
    adminConsoleMobileViewLorryPosted: {
        withParam: `/mw/tso/lorry/active`,
        getUrl: () => `/mw/tso/lorry/active`
    },
    adminConsoleMobileViewInTransitLorries: {
        withParam: `/mw/tso/lorry/in-transit`,
        getUrl: () => `/mw/tso/lorry/in-transit`
    },
    adminConsoleTsoUserLoadOrLorryDetailsPage: {
        withParam: `/mw/tso/:mktType/detail/:entityId`,
        getUrl: (mktType: "load" | "lorry", entityId: number) => {
            return `/mw/tso/${mktType}/detail/${entityId}`;
        }
    },
    adminConsoleMobileViewMarket: {
        withParam: `/mw/tso/market/:mktType`,
        getUrl: (mktType: string) => {
            return `/mw/tso/market/${mktType}`;
        }
    },
    adminConsoleMobileViewEnquiryCards: {
        withParam: `/mw/tso/:type/enquiry-cards`,
        getUrl: (type: string) => `/mw/tso/${type}/enquiry-cards`
    },
    adminConsoleMobileViewEnquiryCardLorriesList: {
        withParam: `/mw/tso/:type/enquiry-cards/live-lorries`,
        getUrl: (type: string) => `/mw/tso/load/enquiry-cards/live-lorries`
    },
    adminConsoleMobileViewEnquiryCardLoadsList: {
        withParam: `/mw/tso/:type/enquiry-cards/live-loads`,
        getUrl: (type: string) => `/mw/tso/lorry/enquiry-cards/live-loads`
    },
    adminMobileViewScreen: {
        withParam: `/mw/tso/:name/`,
        getUrl: (name: string) => `/mw/tso/${name}`
    },
    tsmCashbackStatus: {
        withParam: "/cashback-status",
        getUrl: () => "/cashback-status"
    },
    transporterHome: {
        withParam: "/transporters",
        getUrl: () => "/transporters"
    },
    adminConsoleTicketSystem: {
        withParam: ["/ticket-system/:ticketType", "/ticket-system/:ticketType/:ticketId"],
        getUrl: (ticketType: string, ticketId?: string) => {
            let url = "";
            if (ticketType && ticketId) {
                url = `/ticket-system/${ticketType}/${ticketId}`.replace?.(/ /g, "-")?.toLowerCase?.();
            } else if (ticketType) {
                url = `/ticket-system/${ticketType}`.replace?.(/ /g, "-")?.toLowerCase?.();
            }
            return url;
        }
    },

    adminConsoleTapNgoLoadTicketSystem: {
        withParam: [`/ticket-system/loads/tap-n-go`, "/ticket-system/loads/tap-n-go/:loadId"],
        getUrl: (loadId?: number) => {
            if (loadId) {
                return `/ticket-system/loads/tap-n-go/${loadId}`;
            }
            return `/ticket-system/loads/tap-n-go`;
        }
    },
    adminConsoleRefundRequestTicketSystem: {
        withParam: "/ticket-system/refund-request",
        getUrl: () => "/ticket-system/refund-request"
    },
    adminConsoleVasLeadsTicketSystem: {
        withParam: "/ticket-system/vas-leads",
        getUrl: () => "/ticket-system/vas-leads"
    },
    adminConsoleTicketSystemWithTicketType: {
        withParam: `/ticket-system/:type`,
        getUrl: (path: string) => {
            return `/ticket-system/${path}`;
        }
    },
    adminConsoleLoadTicketSystemWithTicketType: {
        withParam: `/ticket-system/loads/:type`,
        getUrl: (path: string, loadId?: number, queryObj?: Record<string, any>) => {
            let targetUrl = `/ticket-system/loads/${path}`;
            if (loadId) {
                targetUrl += `/${loadId}`;
            }
            if (queryObj) {
                targetUrl += `?${generateQueryString(queryObj)}`;
            }
            return targetUrl;
        }
    },
    adminConsoleCSUsers: {
        withParam: ["/cs-users", "/cs-users/:userId", "/cs-roles/add", "/cs-users/edit/:userId"],
        getUrl: (userId?: number, actionType?: "add" | "edit") => {
            let url = `/cs-users`;

            if (actionType === "add") {
                return `/cs-users/add`;
            }

            if (actionType === "edit" && userId && !isNaN(userId)) {
                return `/cs-users/edit/${userId}`;
            }
            if (userId) {
                return `/cs-users/${userId}`;
            }
            return url;
        }
    },
    adminConsoleCSRoles: {
        withParam: ["/cs-roles", "/cs-roles/:userType"],
        getUrl: (userType?: string) => {
            let url = `/cs-roles`;
            if (userType) {
                url = `/cs-roles/${userType}`;
            }
            return url;
        }
    },
    adminConsoleCSAttendance: {
        withParam: ["/cs-attendance"],
        getUrl: () => {
            let url = `/cs-attendance`;
            return url;
        }
    },
    membership: {
        withParam: "/membership/",
        getUrl: () => "/membership/"
    },
    membershipHistory: {
        withParam: "/membership/history",
        getUrl: () => "/membership/history"
    },
    membershipUpgrade: {
        withParam: "/membership/upgrade",
        getUrl: () => "/membership/upgrade"
    },
    membershipPayment: {
        withParam: "/membership/payment",
        getUrl: () => "/membership/payment"
    },
    membershipFeatures: {
        withParam: "/membership/features",
        getUrl: () => "/membership/features"
    },
    adminConsolePaymentReportSystem: {
        withParam: ["/payment-report/:reportType", "/payment-report/:reportType/:reportId"],
        getUrl: (reportType: string, reportId?: string) => {
            let url = "";
            if (reportType && reportId) {
                url = `/payment-report/${reportType}/${reportId}`.replace?.(/ /g, "-")?.toLowerCase?.();
            } else if (reportType) {
                url = `/payment-report/${reportType}`.replace?.(/ /g, "-")?.toLowerCase?.();
            }
            return url;
        }
    },
    adminMisc: {
        withParam: "/misc/:id",
        getUrl: (id?: string) => `/misc/${id}`
    },
    adminTicketTsoLead: {
        withParam: ["/tso-admin/leads"],
        getUrl: () => {
            let url = `/tso-admin/leads`;
            return url;
        }
    },
    adminTicketTsoSessions: {
        withParam: ["/tso-admin/sessions"],
        getUrl: (companyId?: number, timestamp?: number) => {
            let url = `/tso-admin/sessions`;
            if (companyId && timestamp) {
                url = url + `/${companyId}/${timestamp}`;
            }
            return url;
        }
    },
    adminConsolePathWithScreenId: {
        withParam: ["/:screenId"],
        getUrl: (screenId?: string) => {
            let url = `/${screenId}`;
            return url;
        }
    }
};
